module.exports = __webpack_public_path__ + "img/short-term-savings-insurance-filled.0c7934e.png";